// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Assessment Score Dashboard Styles */
:root {
  --primary-color: #e2e8f0;
  --primary-light: #f1f5f9;
  --primary-dark: #cbd5e1;
  --secondary-color: #F3903F;
  --accent-color: #F3903F;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --text-muted: #94a3b8;
  --bg-primary: #ffffff;
  --bg-secondary: #f8fafc;
  --bg-tertiary: #f1f5f9;
  --success-color: #10b981;
  --warning-color: #f59e0b;
  --danger-color: #ef4444;
  --info-color: #3b82f6;
  --purple-color: #8b5cf6;
  --gradient-primary: linear-gradient(135deg, #e2e8f0 0%, #f1f5f9 100%);
  --gradient-secondary: linear-gradient(135deg, #F3903F 0%, #f97316 100%);
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --border-radius: 12px;
  --border-radius-lg: 16px;
  --transition: all 0.3s ease-in-out;
}

.assessment-score-page {
  min-height: 100vh;
  background: var(--bg-secondary);
  padding: 1rem;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
}

/* Header Styles */
.assessment-header {
  text-align: center;
  margin-bottom: 2rem;
  padding: 2rem 0;
}

.assessment-header h1 {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
  background: var(--gradient-secondary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.assessment-header p {
  font-size: 1.1rem;
  color: var(--text-secondary);
  max-width: 600px;
  margin: 0 auto;
}

/* Tab Navigation */
.tab-navigation {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 2rem;
  background: var(--bg-primary);
  padding: 0.5rem;
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-md);
}

.tab-button {
  padding: 0.75rem 1.5rem;
  border: none;
  background: transparent;
  color: var(--text-secondary);
  font-weight: 500;
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: var(--transition);
  font-size: 0.95rem;
}

.tab-button:hover {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.tab-button.active {
  background: var(--gradient-secondary);
  color: white;
  box-shadow: var(--shadow-sm);
}

/* Assessment Content */
.assessment-content {
  max-width: 1400px;
  margin: 0 auto;
}

/* Assessment Grid */
.assessment-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

/* Score Cards */
.score-card {
  background: var(--bg-primary);
  border-radius: var(--border-radius-lg);
  padding: 2rem;
  box-shadow: var(--shadow-md);
  transition: var(--transition);
  border: 2px solid transparent;
}

.score-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
  border-color: var(--primary-color);
}

.score-card h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 1.5rem;
  text-align: center;
}

.main-score {
  grid-column: span 2;
  text-align: center;
}

.main-score h3 {
  font-size: 1.5rem;
  margin-bottom: 2rem;
}

/* Donut Chart */
.donut-chart {
  position: relative;
  display: inline-block;
  margin: 0 auto;
}

.donut-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.donut-label .percentage {
  display: block;
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1;
}

.donut-label .label {
  display: block;
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin-top: 0.25rem;
}

/* Score Details */
.score-details {
  margin-top: 1.5rem;
}

.score-level {
  text-align: center;
}

.level-badge {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: var(--gradient-secondary);
  color: white;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.score-level p {
  color: var(--text-secondary);
  margin: 0;
  font-size: 0.95rem;
}

/* Bar Chart */
.bar-chart {
  position: relative;
  padding: 1rem 0;
}

.bars {
  display: flex;
  align-items: end;
  justify-content: space-around;
  height: 100%;
  gap: 1rem;
}

.bar-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
  height: 100%;
}

.bar {
  width: 100%;
  max-width: 60px;
  border-radius: 6px 6px 0 0;
  position: relative;
  transition: var(--transition);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  min-height: 20px;
}

.bar:hover {
  transform: scale(1.05);
}

.bar-value {
  position: absolute;
  top: -25px;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-primary);
}

.bar-label {
  margin-top: 0.5rem;
  font-size: 0.75rem;
  color: var(--text-secondary);
  text-align: center;
  transform: rotate(-45deg);
  white-space: nowrap;
  max-width: 80px;
}

/* Line Chart */
.line-chart {
  position: relative;
  padding: 1rem;
}

.line-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
}

.line-label {
  font-size: 0.75rem;
  color: var(--text-secondary);
  text-align: center;
}

/* Radar Chart */
.radar-chart {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.radar-labels {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 1rem;
}

.radar-label {
  font-size: 0.75rem;
  color: var(--text-secondary);
  padding: 0.25rem 0.5rem;
  background: var(--bg-tertiary);
  border-radius: 12px;
}

/* Objectives Section */
.objectives-section {
  max-width: 1200px;
  margin: 0 auto;
}

.objectives-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 1.5rem;
}

.objective-card {
  background: var(--bg-primary);
  border-radius: var(--border-radius-lg);
  padding: 1.5rem;
  box-shadow: var(--shadow-md);
  transition: var(--transition);
  border: 2px solid transparent;
}

.objective-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
  border-color: var(--primary-color);
}

.objective-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.objective-header h4 {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.objective-details {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.detail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.detail-item .label {
  font-size: 0.875rem;
  color: var(--text-secondary);
}

.status {
  padding: 0.25rem 0.75rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
}

.status.excellent {
  background: rgba(16, 185, 129, 0.1);
  color: var(--success-color);
}

.status.good {
  background: rgba(59, 130, 246, 0.1);
  color: var(--info-color);
}

.status.needs-improvement {
  background: rgba(239, 68, 68, 0.1);
  color: var(--danger-color);
}

.priority {
  color: var(--secondary-color);
  font-weight: 600;
  font-size: 0.875rem;
}

.date {
  color: var(--text-muted);
  font-size: 0.875rem;
}

/* Controls Section */
.controls-section {
  max-width: 1200px;
  margin: 0 auto;
}

.controls-overview {
  margin-bottom: 2rem;
}

.control-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.stat-card {
  background: var(--bg-primary);
  border-radius: var(--border-radius);
  padding: 1.5rem;
  text-align: center;
  box-shadow: var(--shadow-sm);
  transition: var(--transition);
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.stat-card h4 {
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.stat-number {
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-primary);
}

.control-mapping {
  background: var(--bg-primary);
  border-radius: var(--border-radius-lg);
  padding: 2rem;
  box-shadow: var(--shadow-md);
}

.control-mapping h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 1.5rem;
  text-align: center;
}

/* Standards Section */
.standards-section {
  max-width: 1200px;
  margin: 0 auto;
}

.standards-overview {
  background: var(--bg-primary);
  border-radius: var(--border-radius-lg);
  padding: 2rem;
  box-shadow: var(--shadow-md);
  margin-bottom: 2rem;
  text-align: center;
}

.standards-details {
  background: var(--bg-primary);
  border-radius: var(--border-radius-lg);
  padding: 2rem;
  box-shadow: var(--shadow-md);
}

.standards-details h3 {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 1.5rem;
  text-align: center;
}

.standards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.standard-card {
  background: var(--bg-secondary);
  border-radius: var(--border-radius);
  padding: 1.5rem;
  transition: var(--transition);
  border: 2px solid transparent;
}

.standard-card:hover {
  transform: translateY(-2px);
  border-color: var(--primary-color);
}

.standard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.standard-header h4 {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.score {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--secondary-color);
}

.progress-bar {
  width: 100%;
  height: 8px;
  background: var(--bg-tertiary);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 1rem;
}

.progress-fill {
  height: 100%;
  background: var(--gradient-secondary);
  border-radius: 4px;
  transition: width 1s ease-in-out;
}

.standard-metrics {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.metric {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.metric-label {
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin-bottom: 0.25rem;
}

.metric-value {
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
}

/* Responsive Design */
@media (max-width: 768px) {
  .assessment-score-page {
    padding: 0.5rem;
  }
  
  .assessment-header h1 {
    font-size: 2rem;
  }
  
  .tab-navigation {
    flex-wrap: wrap;
    gap: 0.25rem;
  }
  
  .tab-button {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
  }
  
  .assessment-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .main-score {
    grid-column: span 1;
  }
  
  .objectives-grid,
  .control-stats,
  .standards-grid {
    grid-template-columns: 1fr;
  }
  
  .bars {
    gap: 0.5rem;
  }
  
  .bar-label {
    font-size: 0.625rem;
    max-width: 60px;
  }
}

@media (max-width: 480px) {
  .assessment-header h1 {
    font-size: 1.75rem;
  }
  
  .assessment-header p {
    font-size: 1rem;
  }
  
  .score-card {
    padding: 1.5rem;
  }
  
  .objective-card,
  .standard-card {
    padding: 1rem;
  }
  
  .bar-label {
    font-size: 0.5rem;
    max-width: 50px;
  }
}

/* Professional Government-Appropriate Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInFromLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideInFromRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Smooth Donut Chart Progress Animation */
@keyframes drawProgress {
  from {
    stroke-dasharray: 0 1000;
  }
  to {
    stroke-dasharray: var(--progress-dasharray);
  }
}

/* Smooth Bar Chart Growth Animation */
@keyframes growBar {
  from {
    height: 0;
    opacity: 0;
  }
  to {
    height: var(--bar-height);
    opacity: 1;
  }
}

/* Smooth Line Chart Drawing Animation */
@keyframes drawLine {
  from {
    stroke-dashoffset: 1000;
  }
  to {
    stroke-dashoffset: 0;
  }
}

/* Smooth Radar Chart Drawing Animation */
@keyframes drawRadar {
  from {
    stroke-dasharray: 0 1000;
    opacity: 0;
  }
  to {
    stroke-dasharray: 1000 0;
    opacity: 1;
  }
}

/* Smooth Pulse Animation for Data Points */
@keyframes pulseIn {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Professional Stagger Animation */
@keyframes staggerIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* Card Animations */
.score-card,
.objective-card,
.standard-card,
.stat-card {
  animation: fadeInUp 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.tab-button {
  animation: slideInFromLeft 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Professional Chart Animations */
.donut-chart svg circle:last-child {
  animation: drawProgress 2.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

.bar {
  animation: growBar 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
  animation-delay: var(--bar-delay, 0s);
}

.line-chart polyline {
  animation: drawLine 2s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

.radar-chart polygon {
  animation: drawRadar 1.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

.radar-chart circle {
  animation: pulseIn 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
  animation-delay: var(--point-delay, 0s);
}

/* Professional Hover Effects */
.bar:hover {
  transform: scale(1.02) translateY(-2px);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.bar:hover .bar-value {
  transform: scale(1.05) translateY(-2px);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.score-card:hover,
.objective-card:hover,
.standard-card:hover {
  transform: translateY(-4px) scale(1.01);
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Staggered Animation for Multiple Elements */
.bar-group:nth-child(1) { --bar-delay: 0.1s; }
.bar-group:nth-child(2) { --bar-delay: 0.2s; }
.bar-group:nth-child(3) { --bar-delay: 0.3s; }
.bar-group:nth-child(4) { --bar-delay: 0.4s; }
.bar-group:nth-child(5) { --bar-delay: 0.5s; }

.radar-chart circle:nth-child(1) { --point-delay: 0.2s; }
.radar-chart circle:nth-child(2) { --point-delay: 0.4s; }
.radar-chart circle:nth-child(3) { --point-delay: 0.6s; }
.radar-chart circle:nth-child(4) { --point-delay: 0.8s; }
.radar-chart circle:nth-child(5) { --point-delay: 1s; }
.radar-chart circle:nth-child(6) { --point-delay: 1.2s; }

/* Custom scrollbar */
.assessment-score-page::-webkit-scrollbar {
  width: 8px;
}

.assessment-score-page::-webkit-scrollbar-track {
  background: var(--bg-tertiary);
  border-radius: 4px;
}

.assessment-score-page::-webkit-scrollbar-thumb {
  background: var(--primary-dark);
  border-radius: 4px;
}

.assessment-score-page::-webkit-scrollbar-thumb:hover {
  background: var(--secondary-color);
} `, "",{"version":3,"sources":["webpack://./src/pages/frameWork/AssessmentScore.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,qEAAqE;EACrE,uEAAuE;EACvE,4CAA4C;EAC5C,kFAAkF;EAClF,oFAAoF;EACpF,qBAAqB;EACrB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,mEAAmE;AACrE;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,qCAAqC;EACrC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,eAAe;EACf,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,aAAa;EACb,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,sCAAsC;EACtC,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,eAAe;EACf,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA,mDAAmD;AACnD;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,yBAAyB;IACzB,UAAU;EACZ;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA,oBAAoB;AACpB;;;;EAIE,6DAA6D;AAC/D;;AAEA;EACE,oEAAoE;AACtE;;AAEA,kCAAkC;AAClC;EACE,0EAA0E;AAC5E;;AAEA;EACE,qEAAqE;EACrE,qCAAqC;AACvC;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,qEAAqE;EACrE,uCAAuC;AACzC;;AAEA,+BAA+B;AAC/B;EACE,uCAAuC;EACvC,yDAAyD;AAC3D;;AAEA;EACE,uCAAuC;EACvC,yDAAyD;AAC3D;;AAEA;;;EAGE,uCAAuC;EACvC,yDAAyD;AAC3D;;AAEA,8CAA8C;AAC9C,0BAA0B,iBAAiB,EAAE;AAC7C,0BAA0B,iBAAiB,EAAE;AAC7C,0BAA0B,iBAAiB,EAAE;AAC7C,0BAA0B,iBAAiB,EAAE;AAC7C,0BAA0B,iBAAiB,EAAE;;AAE7C,mCAAmC,mBAAmB,EAAE;AACxD,mCAAmC,mBAAmB,EAAE;AACxD,mCAAmC,mBAAmB,EAAE;AACxD,mCAAmC,mBAAmB,EAAE;AACxD,mCAAmC,iBAAiB,EAAE;AACtD,mCAAmC,mBAAmB,EAAE;;AAExD,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":["/* Assessment Score Dashboard Styles */\n:root {\n  --primary-color: #e2e8f0;\n  --primary-light: #f1f5f9;\n  --primary-dark: #cbd5e1;\n  --secondary-color: #F3903F;\n  --accent-color: #F3903F;\n  --text-primary: #1e293b;\n  --text-secondary: #64748b;\n  --text-muted: #94a3b8;\n  --bg-primary: #ffffff;\n  --bg-secondary: #f8fafc;\n  --bg-tertiary: #f1f5f9;\n  --success-color: #10b981;\n  --warning-color: #f59e0b;\n  --danger-color: #ef4444;\n  --info-color: #3b82f6;\n  --purple-color: #8b5cf6;\n  --gradient-primary: linear-gradient(135deg, #e2e8f0 0%, #f1f5f9 100%);\n  --gradient-secondary: linear-gradient(135deg, #F3903F 0%, #f97316 100%);\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --border-radius: 12px;\n  --border-radius-lg: 16px;\n  --transition: all 0.3s ease-in-out;\n}\n\n.assessment-score-page {\n  min-height: 100vh;\n  background: var(--bg-secondary);\n  padding: 1rem;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n}\n\n/* Header Styles */\n.assessment-header {\n  text-align: center;\n  margin-bottom: 2rem;\n  padding: 2rem 0;\n}\n\n.assessment-header h1 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 0.5rem;\n  background: var(--gradient-secondary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.assessment-header p {\n  font-size: 1.1rem;\n  color: var(--text-secondary);\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n/* Tab Navigation */\n.tab-navigation {\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-bottom: 2rem;\n  background: var(--bg-primary);\n  padding: 0.5rem;\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-md);\n}\n\n.tab-button {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  background: transparent;\n  color: var(--text-secondary);\n  font-weight: 500;\n  border-radius: var(--border-radius);\n  cursor: pointer;\n  transition: var(--transition);\n  font-size: 0.95rem;\n}\n\n.tab-button:hover {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.tab-button.active {\n  background: var(--gradient-secondary);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n/* Assessment Content */\n.assessment-content {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* Assessment Grid */\n.assessment-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n/* Score Cards */\n.score-card {\n  background: var(--bg-primary);\n  border-radius: var(--border-radius-lg);\n  padding: 2rem;\n  box-shadow: var(--shadow-md);\n  transition: var(--transition);\n  border: 2px solid transparent;\n}\n\n.score-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n  border-color: var(--primary-color);\n}\n\n.score-card h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.main-score {\n  grid-column: span 2;\n  text-align: center;\n}\n\n.main-score h3 {\n  font-size: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n/* Donut Chart */\n.donut-chart {\n  position: relative;\n  display: inline-block;\n  margin: 0 auto;\n}\n\n.donut-label {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n.donut-label .percentage {\n  display: block;\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1;\n}\n\n.donut-label .label {\n  display: block;\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  margin-top: 0.25rem;\n}\n\n/* Score Details */\n.score-details {\n  margin-top: 1.5rem;\n}\n\n.score-level {\n  text-align: center;\n}\n\n.level-badge {\n  display: inline-block;\n  padding: 0.5rem 1rem;\n  background: var(--gradient-secondary);\n  color: white;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 0.875rem;\n  margin-bottom: 0.5rem;\n}\n\n.score-level p {\n  color: var(--text-secondary);\n  margin: 0;\n  font-size: 0.95rem;\n}\n\n/* Bar Chart */\n.bar-chart {\n  position: relative;\n  padding: 1rem 0;\n}\n\n.bars {\n  display: flex;\n  align-items: end;\n  justify-content: space-around;\n  height: 100%;\n  gap: 1rem;\n}\n\n.bar-group {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n  height: 100%;\n}\n\n.bar {\n  width: 100%;\n  max-width: 60px;\n  border-radius: 6px 6px 0 0;\n  position: relative;\n  transition: var(--transition);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  min-height: 20px;\n}\n\n.bar:hover {\n  transform: scale(1.05);\n}\n\n.bar-value {\n  position: absolute;\n  top: -25px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.bar-label {\n  margin-top: 0.5rem;\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  text-align: center;\n  transform: rotate(-45deg);\n  white-space: nowrap;\n  max-width: 80px;\n}\n\n/* Line Chart */\n.line-chart {\n  position: relative;\n  padding: 1rem;\n}\n\n.line-labels {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 0.5rem;\n}\n\n.line-label {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  text-align: center;\n}\n\n/* Radar Chart */\n.radar-chart {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.radar-labels {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-top: 1rem;\n}\n\n.radar-label {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  padding: 0.25rem 0.5rem;\n  background: var(--bg-tertiary);\n  border-radius: 12px;\n}\n\n/* Objectives Section */\n.objectives-section {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.objectives-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 1.5rem;\n}\n\n.objective-card {\n  background: var(--bg-primary);\n  border-radius: var(--border-radius-lg);\n  padding: 1.5rem;\n  box-shadow: var(--shadow-md);\n  transition: var(--transition);\n  border: 2px solid transparent;\n}\n\n.objective-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n  border-color: var(--primary-color);\n}\n\n.objective-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.objective-header h4 {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.objective-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.detail-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.detail-item .label {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n}\n\n.status {\n  padding: 0.25rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.status.excellent {\n  background: rgba(16, 185, 129, 0.1);\n  color: var(--success-color);\n}\n\n.status.good {\n  background: rgba(59, 130, 246, 0.1);\n  color: var(--info-color);\n}\n\n.status.needs-improvement {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--danger-color);\n}\n\n.priority {\n  color: var(--secondary-color);\n  font-weight: 600;\n  font-size: 0.875rem;\n}\n\n.date {\n  color: var(--text-muted);\n  font-size: 0.875rem;\n}\n\n/* Controls Section */\n.controls-section {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.controls-overview {\n  margin-bottom: 2rem;\n}\n\n.control-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-bottom: 2rem;\n}\n\n.stat-card {\n  background: var(--bg-primary);\n  border-radius: var(--border-radius);\n  padding: 1.5rem;\n  text-align: center;\n  box-shadow: var(--shadow-sm);\n  transition: var(--transition);\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n.stat-card h4 {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n}\n\n.stat-number {\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.control-mapping {\n  background: var(--bg-primary);\n  border-radius: var(--border-radius-lg);\n  padding: 2rem;\n  box-shadow: var(--shadow-md);\n}\n\n.control-mapping h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n/* Standards Section */\n.standards-section {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.standards-overview {\n  background: var(--bg-primary);\n  border-radius: var(--border-radius-lg);\n  padding: 2rem;\n  box-shadow: var(--shadow-md);\n  margin-bottom: 2rem;\n  text-align: center;\n}\n\n.standards-details {\n  background: var(--bg-primary);\n  border-radius: var(--border-radius-lg);\n  padding: 2rem;\n  box-shadow: var(--shadow-md);\n}\n\n.standards-details h3 {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin-bottom: 1.5rem;\n  text-align: center;\n}\n\n.standards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n}\n\n.standard-card {\n  background: var(--bg-secondary);\n  border-radius: var(--border-radius);\n  padding: 1.5rem;\n  transition: var(--transition);\n  border: 2px solid transparent;\n}\n\n.standard-card:hover {\n  transform: translateY(-2px);\n  border-color: var(--primary-color);\n}\n\n.standard-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.standard-header h4 {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0;\n}\n\n.score {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--secondary-color);\n}\n\n.progress-bar {\n  width: 100%;\n  height: 8px;\n  background: var(--bg-tertiary);\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 1rem;\n}\n\n.progress-fill {\n  height: 100%;\n  background: var(--gradient-secondary);\n  border-radius: 4px;\n  transition: width 1s ease-in-out;\n}\n\n.standard-metrics {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n}\n\n.metric {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.metric-label {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  margin-bottom: 0.25rem;\n}\n\n.metric-value {\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .assessment-score-page {\n    padding: 0.5rem;\n  }\n  \n  .assessment-header h1 {\n    font-size: 2rem;\n  }\n  \n  .tab-navigation {\n    flex-wrap: wrap;\n    gap: 0.25rem;\n  }\n  \n  .tab-button {\n    padding: 0.5rem 1rem;\n    font-size: 0.875rem;\n  }\n  \n  .assessment-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  \n  .main-score {\n    grid-column: span 1;\n  }\n  \n  .objectives-grid,\n  .control-stats,\n  .standards-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .bars {\n    gap: 0.5rem;\n  }\n  \n  .bar-label {\n    font-size: 0.625rem;\n    max-width: 60px;\n  }\n}\n\n@media (max-width: 480px) {\n  .assessment-header h1 {\n    font-size: 1.75rem;\n  }\n  \n  .assessment-header p {\n    font-size: 1rem;\n  }\n  \n  .score-card {\n    padding: 1.5rem;\n  }\n  \n  .objective-card,\n  .standard-card {\n    padding: 1rem;\n  }\n  \n  .bar-label {\n    font-size: 0.5rem;\n    max-width: 50px;\n  }\n}\n\n/* Professional Government-Appropriate Animations */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideInFromLeft {\n  from {\n    opacity: 0;\n    transform: translateX(-30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideInFromRight {\n  from {\n    opacity: 0;\n    transform: translateX(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    opacity: 0;\n    transform: scale(0.8);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Smooth Donut Chart Progress Animation */\n@keyframes drawProgress {\n  from {\n    stroke-dasharray: 0 1000;\n  }\n  to {\n    stroke-dasharray: var(--progress-dasharray);\n  }\n}\n\n/* Smooth Bar Chart Growth Animation */\n@keyframes growBar {\n  from {\n    height: 0;\n    opacity: 0;\n  }\n  to {\n    height: var(--bar-height);\n    opacity: 1;\n  }\n}\n\n/* Smooth Line Chart Drawing Animation */\n@keyframes drawLine {\n  from {\n    stroke-dashoffset: 1000;\n  }\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n/* Smooth Radar Chart Drawing Animation */\n@keyframes drawRadar {\n  from {\n    stroke-dasharray: 0 1000;\n    opacity: 0;\n  }\n  to {\n    stroke-dasharray: 1000 0;\n    opacity: 1;\n  }\n}\n\n/* Smooth Pulse Animation for Data Points */\n@keyframes pulseIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.3);\n  }\n  50% {\n    opacity: 0.8;\n    transform: scale(1.1);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Professional Stagger Animation */\n@keyframes staggerIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n/* Card Animations */\n.score-card,\n.objective-card,\n.standard-card,\n.stat-card {\n  animation: fadeInUp 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.tab-button {\n  animation: slideInFromLeft 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n/* Professional Chart Animations */\n.donut-chart svg circle:last-child {\n  animation: drawProgress 2.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;\n}\n\n.bar {\n  animation: growBar 1.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;\n  animation-delay: var(--bar-delay, 0s);\n}\n\n.line-chart polyline {\n  animation: drawLine 2s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;\n}\n\n.radar-chart polygon {\n  animation: drawRadar 1.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;\n}\n\n.radar-chart circle {\n  animation: pulseIn 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;\n  animation-delay: var(--point-delay, 0s);\n}\n\n/* Professional Hover Effects */\n.bar:hover {\n  transform: scale(1.02) translateY(-2px);\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.bar:hover .bar-value {\n  transform: scale(1.05) translateY(-2px);\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n.score-card:hover,\n.objective-card:hover,\n.standard-card:hover {\n  transform: translateY(-4px) scale(1.01);\n  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n/* Staggered Animation for Multiple Elements */\n.bar-group:nth-child(1) { --bar-delay: 0.1s; }\n.bar-group:nth-child(2) { --bar-delay: 0.2s; }\n.bar-group:nth-child(3) { --bar-delay: 0.3s; }\n.bar-group:nth-child(4) { --bar-delay: 0.4s; }\n.bar-group:nth-child(5) { --bar-delay: 0.5s; }\n\n.radar-chart circle:nth-child(1) { --point-delay: 0.2s; }\n.radar-chart circle:nth-child(2) { --point-delay: 0.4s; }\n.radar-chart circle:nth-child(3) { --point-delay: 0.6s; }\n.radar-chart circle:nth-child(4) { --point-delay: 0.8s; }\n.radar-chart circle:nth-child(5) { --point-delay: 1s; }\n.radar-chart circle:nth-child(6) { --point-delay: 1.2s; }\n\n/* Custom scrollbar */\n.assessment-score-page::-webkit-scrollbar {\n  width: 8px;\n}\n\n.assessment-score-page::-webkit-scrollbar-track {\n  background: var(--bg-tertiary);\n  border-radius: 4px;\n}\n\n.assessment-score-page::-webkit-scrollbar-thumb {\n  background: var(--primary-dark);\n  border-radius: 4px;\n}\n\n.assessment-score-page::-webkit-scrollbar-thumb:hover {\n  background: var(--secondary-color);\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
